module.exports = __webpack_public_path__ + "img/default-profile.50f4f2c5.png";